module.exports = __webpack_public_path__ + "static/js_bootcamp-2eb65fe585acff2b8e26c29c85707b57.jpg";